<template>
  <!-- <div id="app"> -->
  <router-view />
  <!-- </div> -->
</template>
<script>
export default {
  mounted() {
    // document.documentElement.style.fontSize =
    //   (document.documentElement.clientWidth / 1920) * 18 + "px";
    // console.log(
    //   "app fontsize:",
    //   window.screen.width,
    //   document.documentElement.style.fontSize
    // );
  }
};
</script>
<style lang="scss">
body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  box-sizing: border-box;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.sk-link {
  color: #000;
  text-decoration: underline;
}

.btn-senkoo3 {
  background: #000;
  border-radius: 0;
  border: none;
  font-weight: 500;
  color: #fff;
}
</style>
